/*
  Se utiliza `useEffect` aquí para manejar una inconsistencia entre el renderizado del servidor y el cliente
  causada por un problema en el componente `Andes/technical-error` (ver issue #1723). Esta inconsistencia
  provoca un error de React debido a la estricta verificación de `hydrateRoot`, que detecta diferencias entre
  el renderizado en ambas etapas. El `useEffect` garantiza que el código solo se ejecute en el cliente,
  evitando el error.

  Issue relacionado: https://github.com/melisource/fury_frontend-andes-ui/issues/1723
*/

const React = require('react');
const { ErrorScreen } = require('@andes/technical-error');
const PropTypes = require('prop-types');

const GeneralError = ({ title, description, status, link }) => {
  const [isClient, setIsClient] = React.useState(false);

  React.useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }
  return (
    <ErrorScreen
      title={title}
      description={description}
      action={{
        onClick: link?.onClick,
        text: link?.text,
      }}
      errorCode={status}
    />
  );
};

GeneralError.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  status: PropTypes.string.isRequired,
  link: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
  }),
};

module.exports = GeneralError;
